import { RadioGroupState } from '@react-stately/radio';
import * as React from 'react';

export const RadioContext = React.createContext<RadioGroupState>(undefined);

export function useRadioContext() {
  return React.useContext(RadioContext);
}
